const axios = require('axios')
const nuxtConfig = require('~/nuxt.config').default

export const state = () => ({
	agents: [],
	agentIdList: [],
	agentsTopCommission: null,
	agentsTopListing: null,
	agentsTopManagement: null,
	agentRegister: {
		id: null,
		token: null
	}
})

export const getters = {
	getAgent: state => (id) => {
		id = parseInt(id)
		let agent = state.agents.find(x => x.id === id)
		if (typeof agent === 'undefined')
			return

		return agent
	},

	getAgentIdList: state => (path) => {
		if (state.agentIdList.length === 0)
			return null

		let list = state.agentIdList.find(x => x.key === path)
		if (list) {
			return list
		}
		return null
	},

	agentsTopCommission: state => state.agentsTopCommission,
	agentsTopListing: state => state.agentsTopListing,
	agentsTopManagement: state => state.agentsTopManagement
}

export const mutations = {
	storeAgent (state, agent) {
		let index = state.agents.findIndex(a => a.id.toString() === agent.id.toString())

		if (index === -1) {
			state.agents.push(agent)
		} else {
			state.agents[index] = agent
		}
	},

	storeAgentPropertyIds (state, data) {
		let agent = state.agents.find(a => a.id.toString() === data.id.toString())

		agent.propertyIds = data.ids
	},

	storeAgentIdList (state, obj) {
		let data = {
			key: obj.path,
			ids: obj.ids,
			last_page: obj.last_page,
			total: obj.total
		}
		state.agentIdList.push(data)
	},

	storeTopCommission (state, list) {
		state.agentsTopCommission = list
	},
	storeTopListing (state, list) {
		state.agentsTopListing = list
	},
	storeTopManagement (state, list) {
		state.agentsTopManagement = list
	},

	updateAgentRegister (state, data) {
		state.agentRegister = Object.assign(state.agentRegister, data)
	}
}

export const actions = {
	urlValidation ({ commit }, data) {
		return new Promise((resolve, reject) => {

			let form = new FormData()
			form.append('token', data.token)

			axios.post(`${nuxtConfig.env.apiURL}/agentRegisterCheckToken`, form, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(res => {
				if (res.data && res.data.error === 0) {
					commit('updateAgentRegister', {
						token: data.token,
						id: res.data.id,
						contract_image: res.data.contract_image,
						agent_id: res.data.agent_id,
						extend: res.data.extend,
						joint: res.data.joint,
						renew: res.data.renew
					})
					resolve(res.data)
				} else if (res.data.error === 422) { // Invalid token
					reject({
						code: 'invalid-token',
						...res.data
					})
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	agentJointSearch ({ state }, data) {
		return new Promise((resolve, reject) => {

			let form = new FormData()
			for (let key in data) {
				// skip loop if the property is from prototype
				if (!data.hasOwnProperty(key)) continue

				form.append(key, data[key])
			}
			form.append('token', state.agentRegister.token)

			axios.post(`${nuxtConfig.env.apiURL}/agentRegisterCheckMainAgent`, form, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res) => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else if (res.data.error === 406) { // Invalid agent id
					reject({
						code: 'invalid-agent-id',
						...res.data
					})
				} else if (res.data.error === 409) { // This Agent already exists
					reject({
						code: 'agent-already-has-joint',
						...res.data
					})
				} else if (res.data.error === 422) { // Maximum attempt limit
					reject({
						code: 'maximum-attempt-limit',
						...res.data
					})
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	requestOTP ({ state }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`${nuxtConfig.env.apiURL}/agentRegisterRequestOtp`, {
				...data,
				token: state.agentRegister.token
			}).then(res => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	agentSubmitOTP ({ state }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`${nuxtConfig.env.apiURL}/agentRegisterSubmitOTP`, {
				...data,
				token: state.agentRegister.token
			}).then((res) => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					if (res.data.error === 422) { // Invalid OTP
						reject({
							code: 'otp-invalid',
							...res.data
						})
					} else {
						reject({
							code: 'unknown',
							...res.data
						})
					}
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	agentSubmitInfo ({ commit, state }, data) {
		return new Promise((resolve, reject) => {

			let form = new FormData()
			for (let key in data) {
				// skip loop if the property is from prototype
				if (!data.hasOwnProperty(key)) continue

				form.append(key, data[key] || '')
			}
			form.append('token', state.agentRegister.token)

			axios.post(`${nuxtConfig.env.apiURL}/agentRegister`, form, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res) => {
				if (res.data && res.data.error === 0) {
					commit('updateAgentRegister', { id: res.data.id })
					resolve(res.data)
				} else if (res.data.error === 406) { // Invalid agent reference
					reject({
						code: 'invalid-agent-ref',
						...res.data
					})
				} else if (res.data.error === 409) { // Email already exists
					reject({
						code: 'duplicate-email',
						...res.data
					})
				} else if (res.data.error === 422) { // Invalid token
					reject({
						code: 'invalid-token',
						...res.data
					})
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	agentSubmitQuestionnaire ({ state }, data) {
		return new Promise((resolve, reject) => {
			if (!state.agentRegister || !state.agentRegister.id) {
				reject({
					code: 'invalid-register-id'
				})
				return
			}

			axios.post(`${nuxtConfig.env.apiURL}/agentRegisterSubmitQuestionnaire`, {
				id: state.agentRegister.id,
				questionnaire: data
			}).then((res) => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	agentSubmitQuiz ({ state }) {
		return new Promise((resolve, reject) => {
			if (!state.agentRegister || !state.agentRegister.id) {
				reject({
					code: 'invalid-register-id'
				})
				return
			}

			axios.post(`${nuxtConfig.env.apiURL}/agentRegisterSubmitQuiz`, {
				id: state.agentRegister.id,
			}).then((res) => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject({
						code: 'unknown',
						...res.data
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	agentSubmitContract ({ state }) {
		return new Promise((resolve, reject) => {

			let form = new FormData()
			if (state.agentRegister && state.agentRegister.id) {
				form.append('id', state.agentRegister.id)
			} else {
				reject({
					code: 'invalid-register-id'
				})
				return
			}

			axios.post(`${nuxtConfig.env.apiURL}/agentRegisterSubmitContract`, form, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res) => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject(res.data)
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	agentSubmitUpload ({ state }, data) {
		return new Promise((resolve, reject) => {
			let form = new FormData()
			if (state.agentRegister && state.agentRegister.id) {
				form.append('id', state.agentRegister.id)
			} else {
				reject({
					code: 'invalid-register-id'
				})
				return
			}

			for (let key in data) {
				// skip loop if the property is from prototype
				if (!data.hasOwnProperty(key)) continue

				form.append(key, data[key] || '')
			}

			axios.post(`${nuxtConfig.env.apiURL}/agentRegisterUploadFile`, form, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res) => {
				if (res.data && res.data.error === 0) {
					resolve(res.data)
				} else {
					reject(res.data)
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	getAgent ({ commit, state }, id) {
		id = isNaN(id) ? id : parseInt(id)

		return new Promise((resolve, reject) => {
			var agent = state.agents.find(x => x.id === id)
			if (agent) {
				resolve(agent)
			} else {
				// axios.get(`${nuxtConfig.env.apiURL}/getAgent?id=${id}`, {headers: {'Referer': 'tb.co.th'}}).then((res) => {
				axios.get(`${nuxtConfig.env.apiURL}/getAgent?id=${id}`).then((res) => {
					let data = res.data

					if (data.agent) {
						commit('storeAgent', data.agent)
						resolve(state.agents.find(x => x.id === data.agent.id))
					} else {
						resolve(null)
					}
				}).catch(e => {
					reject(e)
				})
			}
		})
	},

	getAgentProperty ({ commit, dispatch }, id) {
		return new Promise((resolve, reject) => {
			dispatch('getAgent', id).then(agent => {
				if (agent.propertyIds) {
					// dispatch('property/getPropertyList', agent.propertyIds, { root: true }).then(propertyList => {
					// 	resolve(propertyList)
					// })
					resolve(agent.propertyIds)
				} else {
					dispatch('property/getPropertyListByAgent', id, { root: true }).then(data => {
						commit('storeAgentPropertyIds', { id, ids: data.agent_propertyList_id })

						// resolve(data.propertyList)
						resolve(data.agent_propertyList_id)
					})
				}
			}).catch(e => {
				reject(e)
			})
		})
	},

	getTopAgent ({ commit }) {
		return new Promise((resolve, reject) => {
			axios.get(`${nuxtConfig.env.apiURL}/getTopAgent`).then((res) => {
				let data = res.data

				commit('storeTopCommission', data.commission)
				commit('storeTopListing', data.listing)
				commit('storeTopManagement', data.management)

				for(let agent of data.agentList) {
					commit('storeAgent', agent)
				}

				resolve(data)
			}).catch(e => {
				reject(e)
			})
		})
	},

	getAgentList ({ commit, getters }, ids) {
		return new Promise((resolve, reject) => {
			let agentList = []
			let notExistList = []
			let agent

			// Get agent that store in state
			for (let id of ids) {
				agent = getters.getAgent(id)
				if (agent) {
					agentList.push(agent)
				} else {
					notExistList.push(id)
				}
			}

			// Get agent if not exist
			if (notExistList.length > 0) {
				let idsParam = ''
				for (let id of notExistList) {
					idsParam += `id[]=${id}&`
				}
				axios.get(`${nuxtConfig.env.apiURL}/getAgentList?${idsParam}`).then((res) => {
					let data = res.data

					for(agent of data.agentList) {
						commit('storeAgent', agent)
						agentList.push(agent)
					}
					resolve(agentList)
				}).catch(e => {
					reject(e)
				})
			} else {
				resolve(agentList)
			}
		})
	},

	searchAgent ({ dispatch, getters }, query) {
		return new Promise((resolve, reject) => {

			let path = `${nuxtConfig.env.apiURL}/getAgentList`
			if (Object.keys(query).length > 0 && query.constructor === Object) { // Has query to search
				path += '?'
				for(let key in query) {
					if (Array.isArray(query[key]) && query[key].length > 0) {
						for (let item of query[key]) {
							path += `${key}[]=${item}&`
						}
					} else {
						path += `${key}=${query[key]}&`
					}
				}
			}

			let agentObj = getters.getAgentIdList(path)
			if(agentObj) {
				dispatch('getAgentList', agentObj.ids).then(agentList => {
					resolve({
						agentList,
						total: agentObj.total
					})
				}).catch(error => {
					reject(error)
				})
			} else {
				dispatch('agentInquiry', path).then(obj => {
					resolve({
						agentList: obj.data,
						total: obj.total
					})
				}).catch(error => {
					reject(error)
				})
			}
		})
	},

	agentInquiry ({ commit }, path) {
		return new Promise((resolve, reject) => {
			axios.get(path).then((res) => {
				let data = res.data
				commit('storeAgentIdList', {
					path: path,
					ids: data.agents_id,
					total: data.agentList.total,
					last_page: data.agentList.last_page
				})
				data.agentList.data.forEach((agent) => {
					commit('storeAgent', agent)
				})

				resolve(data.agentList)
			}).catch(e => {
				reject(e)
			})
		})
	},

	/* eslint-disable no-unused-vars */
	agentQuery ({ commit }, text) {
		return new Promise((resolve, reject) => {
			let path = `${nuxtConfig.env.apiURL}/search-text-agent?text=${text}`
			axios.get(path).then((res) => {
				let data = res.data

				resolve(data.lists)
			}).catch(e => {
				reject(e)
			})
		})
	},
	/* eslint-enable no-unused-vars */
}
